<script>
	export let cols = "12";

	let className = $$props.class ? $$props.class : "";
</script>

<div class="col-md-{cols} {className}">
	<slot></slot>
</div>
